import { useNavigate } from "react-router-dom";
import { useStateContext } from "../Contexts/ContextProvider";

const Card = ({ icon, title, value, coll = "primary", users = [], link, action = "View report" }) => {
  const navigate = useNavigate();
  const { setData } = useStateContext();

  const handleShow = () => {
    setData(users);
    navigate(link || "/dashboard/reports");
  };

  const colorMap = {
    dark: "metric-icon--dark",
    warning: "metric-icon--warning",
    success: "metric-icon--success",
    info: "metric-icon--info",
    primary: "metric-icon--primary",
    danger: "metric-icon--danger",
  };

  const iconTone = colorMap[coll] || colorMap.primary;

  return (
    <div className="metric-card">
      <div className="metric-card__top">
        <span className={`metric-card__icon ${iconTone}`} aria-hidden="true">
          <i className="material-icons">{icon}</i>
        </span>
        <span className="metric-card__label">{title}</span>
      </div>
      <p className="metric-card__value">{value}</p>
      <button className="metric-card__action" onClick={handleShow} type="button">
        {action}<i className="material-icons" aria-hidden="true">arrow_forward</i>
      </button>
    </div>
  );
};

export default Card;